/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["data-list-table[_ngcontent-%COMP%]{display:block;margin:1rem;max-width:600px}data-list-table[_ngcontent-%COMP%]   .mat-form-field[_ngcontent-%COMP%]{width:200px}data-list-table[_ngcontent-%COMP%]   .mat-select[_ngcontent-%COMP%]{padding-top:0}data-list-table[_ngcontent-%COMP%]     .mat-select-trigger{min-width:80px}data-list-table[_ngcontent-%COMP%]     .cdk-column-name{flex:2}button.action[_ngcontent-%COMP%]{margin:1rem}  mat-select.mat-select{padding-top:0}"];
export { styles as styles };
